import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const ManageFiltersWrapper = styled('div')`
  display: flex;
  border-radius: 18px;
  border: 1px solid;
  padding: 5px 6px 5px 13px;
  cursor: pointer;
  height: 40px;
  align-items: center;
  justify-content: center;
  border-color: ${colors.primary};
  color: ${colors.primary};
  gap: 5px;
  margin-left: auto;
  box-shadow: 2px 4px 2px 0px #2c607b26;
  background-color: ${(props: { $filtersApplied: boolean }) => (props.$filtersApplied ? `${colors.primary}` : `${colors.white}`)};
`

export const ManageFiltersText = styled('span')`
  display: inline-block;
  color: ${(props: { $filtersApplied: boolean }) => (props.$filtersApplied ? `${colors.white}` : `${colors.primary}`)};
`

export const StyledFilterButtonButton = styled('span')<{ $filtersApplied?: boolean; $disabled?: boolean }>`
  background-color: ${({ $filtersApplied }: { $filtersApplied?: boolean }) => ($filtersApplied ? colors.white : colors.primary)};
  border-radius: 15px;
  color: ${colors.white};
  line-height: 19px;
  padding: 3px 5px;
  display: flex;
  cursor: pointer;
  opacity: ${({ $disabled }: { $disabled?: boolean }) => ($disabled ? '0.4' : '1')};
`
